import React from 'react';
import { motion } from 'framer-motion';
import { Mark } from '../common/Logo';

const FounderNote = () => {
  return (
    <section className="relative py-28 md:py-32 bg-canvas-black">
      <div className="container-prose max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="relative p-10 md:p-14 rounded-3xl border border-white/[0.07] bg-gradient-to-br from-white/[0.025] to-transparent"
        >
          <div className="absolute -top-px left-10 right-10 h-px bg-gradient-to-r from-transparent via-amber/40 to-transparent" />

          <div className="flex items-center gap-3 mb-8">
            <Mark size={28} />
            <span className="text-[10.5px] font-semibold tracking-[0.16em] uppercase text-ink-faint">
              A note from the founder
            </span>
          </div>

          <blockquote className="text-[20px] md:text-[24px] leading-[1.45] font-light tracking-tight text-canvas-white text-balance">
            <span className="text-amber">"</span>
            I started Core Trade after watching senior traders across the Gulf burn
            their afternoons re-typing tickets they'd already booked in their head
            an hour earlier. The trade was done. The booking was the bottleneck.
            That gap is what we're closing.
            <span className="text-amber">"</span>
          </blockquote>

          <div className="mt-10 pt-8 border-t border-white/[0.06] flex items-center justify-between gap-4 flex-wrap">
            <div>
              <p className="text-[13.5px] font-semibold text-canvas-white tracking-tight">
                Shayan · Founder, Core Trade
              </p>
              <p className="text-[12.5px] text-ink-faint mt-0.5">
                Pre-launch — scheduling demos with senior traders across the GCC
              </p>
            </div>
            <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/[0.04] ring-1 ring-white/[0.08]">
              <span className="w-1.5 h-1.5 rounded-full bg-amber animate-pulse-soft" />
              <span className="text-[11px] font-medium tracking-wide uppercase text-ink-faint">
                Launching H2 2026
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FounderNote;
